import {BasePageLayout} from "../components/grouping/BasePageLayout";
import {useSectors} from "../api/sectorsapi";
import {Button, Col, Row} from "react-bootstrap";
import Collapse from "react-bootstrap/Collapse";
import {useState} from "react";
import {InfoText} from "./ClubPage";

export function SectorPage(props) {
    const {sectors} = useSectors();
    return <BasePageLayout title={'Sectors'}>
        {sectors?.map(s => <SectorItem key={s.id} sector={s}/>)}
    </BasePageLayout>
}

function SectorItem(props) {
    const {sector} = props;
    const [open, setOpen] = useState(false);
    return <Col xs={12} className={'g-0 justify-content-start'}>
        <Button className={"text-decoration-none btn-light"} variant={"link"} onClick={() => setOpen(!open)}>
            <InfoText contentClassName={"text-primary"} title={"Sector"} content={sector?.sectorNaam}/>
        </Button>
        <Collapse in={open}>
            <Row className={'g-0'}>
                <SectorDetails sector={sector}/>
            </Row>
        </Collapse>
    </Col>
}

function SectorDetails(props) {
    const {sector} = props;
    return <Col className={'border border-2 p-2 rounded-2'}>
        <h4>Voorzitter: </h4>
        <Row className={'g-0 p-2'}>
            <Col xs={12} className={'me-2'}>
                <InfoText title={'Naam'} content={`${sector.voorzitterNaam} ${sector.voorzitterVoornaam}`}/>

            </Col>
            <Col xs={12} className={'me-2'}>
                <InfoText title={'Email'} content={`${sector.voorzitterEmail} `}/>

            </Col>

        </Row>
        <h4>Secretaris: </h4>
        <Row className={'g-0 p-2'}>
            <Col xs={12} className={'me-2'}>
                <InfoText title={'Naam'} content={`${sector.secretarisNaam} ${sector.secretarisVoornaam}`}/>

            </Col>
            <Col xs={12} className={'me-2'}>
                <InfoText title={'Email'} content={`${sector.secretarisEmail} `}/>
            </Col>

        </Row>

    </Col>
}


